namespace RioERP.Invoices {
    export interface InvoiceOrdersRow {
        Id?: number;
        OrderId?: number;
        InvoiceId?: number;
        OrderCustomerId?: number;
        OrderOrderNumber?: string;
        OrderCustomerName?: string;
        OrderCustomerEmail1?: string;
        OrderCustomerEmail2?: string;
        OrderCustomerMobile1?: string;
        OrderCustomerMobile2?: string;
        OrderBillingAddress1?: string;
        OrderBillingAddress2?: string;
        OrderBillingCity?: string;
        OrderBillingStateId?: number;
        OrderBillingPincode?: number;
        OrderShippingToName?: string;
        OrderShippingAddress1?: string;
        OrderShippingAddress2?: string;
        OrderShippingCity?: string;
        OrderShippingStateId?: number;
        OrderShippingPincode?: number;
        OrderEOrderStatus?: number;
        OrderEShippingType?: number;
        OrderDiscountPer?: number;
        OrderOrderDate?: string;
        OrderESourceType?: number;
        OrderSourceName?: string;
        OrderEmailSendCount?: number;
        OrderIsEmailSent?: boolean;
        OrderEPaymentStatus?: number;
        OrderLastEmailSentDate?: string;
        OrderFranchiseeId?: number;
        OrderEOrderProcessBy?: number;
        OrderDiscountCoupon?: string;
        OrderDiscountAmount?: number;
        OrderGrossAmount?: number;
        OrderNetAmount?: number;
        OrderTaxableAmount?: number;
        OrderEShippingStatus?: number;
        OrderEInvoiceStatus?: number;
        OrderMailId?: number;
        OrderEPaymentType?: number;
        OrderGstin?: string;
        OrderExpectedShippingDate?: string;
        OrderEInvoiceTo?: number;
        OrderEFranchiseeDiscountType?: number;
        OrderEFranchiseeDiscount?: number;
        OrderFranchiseeDiscountValue?: number;
        OrderFranchiseeDiscountAmount?: number;
        OrderInvoiceCompanyId?: number;
        OrderShippingNote?: string;
        OrderSourceOrderNumber?: string;
        OrderIsActive?: boolean;
        OrderInsertUserId?: number;
        OrderInsertDate?: string;
        OrderUpdateUserId?: number;
        OrderUpdateDate?: string;
        OrderVendorId?: number;
        InvoiceInvoicenumber?: string;
        InvoiceInvoiceDate?: string;
        InvoiceInvoiceCompanyId?: number;
        InvoiceEInvoiceType?: number;
        InvoiceEInvoiceTo?: number;
        InvoiceCustomerId?: number;
        InvoiceFranchiseeId?: number;
        InvoiceDiscountAmount?: number;
        InvoiceGrossAmount?: number;
        InvoiceNetAmount?: number;
        InvoiceTaxableAmount?: number;
        InvoiceIsRecalculated?: boolean;
        InvoiceEInvoiceStatus?: number;
        InvoiceBillingAddress1?: string;
        InvoiceBillingAddress2?: string;
        InvoiceBillingCity?: string;
        InvoiceBillingStateId?: number;
        InvoiceBillingPincode?: number;
        InvoiceIsActive?: boolean;
        InvoiceInsertUserId?: number;
        InvoiceInsertDate?: string;
        InvoiceUpdateUserId?: number;
        InvoiceUpdateDate?: string;
    }

    export namespace InvoiceOrdersRow {
        export const idProperty = 'Id';
        export const localTextPrefix = 'Invoices.InvoiceOrders';
        export const deletePermission = 'Invoices:InvoicesManagement:Modify';
        export const insertPermission = 'Invoices:InvoicesManagement:Modify';
        export const readPermission = 'Invoices:InvoicesManagement:View';
        export const updatePermission = 'Invoices:InvoicesManagement:Modify';

        export declare const enum Fields {
            Id = "Id",
            OrderId = "OrderId",
            InvoiceId = "InvoiceId",
            OrderCustomerId = "OrderCustomerId",
            OrderOrderNumber = "OrderOrderNumber",
            OrderCustomerName = "OrderCustomerName",
            OrderCustomerEmail1 = "OrderCustomerEmail1",
            OrderCustomerEmail2 = "OrderCustomerEmail2",
            OrderCustomerMobile1 = "OrderCustomerMobile1",
            OrderCustomerMobile2 = "OrderCustomerMobile2",
            OrderBillingAddress1 = "OrderBillingAddress1",
            OrderBillingAddress2 = "OrderBillingAddress2",
            OrderBillingCity = "OrderBillingCity",
            OrderBillingStateId = "OrderBillingStateId",
            OrderBillingPincode = "OrderBillingPincode",
            OrderShippingToName = "OrderShippingToName",
            OrderShippingAddress1 = "OrderShippingAddress1",
            OrderShippingAddress2 = "OrderShippingAddress2",
            OrderShippingCity = "OrderShippingCity",
            OrderShippingStateId = "OrderShippingStateId",
            OrderShippingPincode = "OrderShippingPincode",
            OrderEOrderStatus = "OrderEOrderStatus",
            OrderEShippingType = "OrderEShippingType",
            OrderDiscountPer = "OrderDiscountPer",
            OrderOrderDate = "OrderOrderDate",
            OrderESourceType = "OrderESourceType",
            OrderSourceName = "OrderSourceName",
            OrderEmailSendCount = "OrderEmailSendCount",
            OrderIsEmailSent = "OrderIsEmailSent",
            OrderEPaymentStatus = "OrderEPaymentStatus",
            OrderLastEmailSentDate = "OrderLastEmailSentDate",
            OrderFranchiseeId = "OrderFranchiseeId",
            OrderEOrderProcessBy = "OrderEOrderProcessBy",
            OrderDiscountCoupon = "OrderDiscountCoupon",
            OrderDiscountAmount = "OrderDiscountAmount",
            OrderGrossAmount = "OrderGrossAmount",
            OrderNetAmount = "OrderNetAmount",
            OrderTaxableAmount = "OrderTaxableAmount",
            OrderEShippingStatus = "OrderEShippingStatus",
            OrderEInvoiceStatus = "OrderEInvoiceStatus",
            OrderMailId = "OrderMailId",
            OrderEPaymentType = "OrderEPaymentType",
            OrderGstin = "OrderGstin",
            OrderExpectedShippingDate = "OrderExpectedShippingDate",
            OrderEInvoiceTo = "OrderEInvoiceTo",
            OrderEFranchiseeDiscountType = "OrderEFranchiseeDiscountType",
            OrderEFranchiseeDiscount = "OrderEFranchiseeDiscount",
            OrderFranchiseeDiscountValue = "OrderFranchiseeDiscountValue",
            OrderFranchiseeDiscountAmount = "OrderFranchiseeDiscountAmount",
            OrderInvoiceCompanyId = "OrderInvoiceCompanyId",
            OrderShippingNote = "OrderShippingNote",
            OrderSourceOrderNumber = "OrderSourceOrderNumber",
            OrderIsActive = "OrderIsActive",
            OrderInsertUserId = "OrderInsertUserId",
            OrderInsertDate = "OrderInsertDate",
            OrderUpdateUserId = "OrderUpdateUserId",
            OrderUpdateDate = "OrderUpdateDate",
            OrderVendorId = "OrderVendorId",
            InvoiceInvoicenumber = "InvoiceInvoicenumber",
            InvoiceInvoiceDate = "InvoiceInvoiceDate",
            InvoiceInvoiceCompanyId = "InvoiceInvoiceCompanyId",
            InvoiceEInvoiceType = "InvoiceEInvoiceType",
            InvoiceEInvoiceTo = "InvoiceEInvoiceTo",
            InvoiceCustomerId = "InvoiceCustomerId",
            InvoiceFranchiseeId = "InvoiceFranchiseeId",
            InvoiceDiscountAmount = "InvoiceDiscountAmount",
            InvoiceGrossAmount = "InvoiceGrossAmount",
            InvoiceNetAmount = "InvoiceNetAmount",
            InvoiceTaxableAmount = "InvoiceTaxableAmount",
            InvoiceIsRecalculated = "InvoiceIsRecalculated",
            InvoiceEInvoiceStatus = "InvoiceEInvoiceStatus",
            InvoiceBillingAddress1 = "InvoiceBillingAddress1",
            InvoiceBillingAddress2 = "InvoiceBillingAddress2",
            InvoiceBillingCity = "InvoiceBillingCity",
            InvoiceBillingStateId = "InvoiceBillingStateId",
            InvoiceBillingPincode = "InvoiceBillingPincode",
            InvoiceIsActive = "InvoiceIsActive",
            InvoiceInsertUserId = "InvoiceInsertUserId",
            InvoiceInsertDate = "InvoiceInsertDate",
            InvoiceUpdateUserId = "InvoiceUpdateUserId",
            InvoiceUpdateDate = "InvoiceUpdateDate"
        }
    }
}
